
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Mumbaitopuneonewaycab() {



    const cardData =
    {
        keyword: 'Mumbai to Pune One Way Cab',
        heading: 'Meghana Cab : Mumbai to Pune One Way Cab',
        headingDescription: 'Meghana Cab offers Mumbai to Pune One Way Cab service, providing a comfortable, affordable, and stress-free travel option for individuals, families, and corporate travelers. Whether you are returning from a trip, heading home, or traveling for work, our wide range of well-maintained vehicles—including Hatchbacks, Sedans, SUVs, Innova Crysta, and Tempo Travellers—ensures a smooth ride. Enjoy doorstep pickup anywhere in Mumbai, professional drivers, transparent one-way pricing, and 24/7 customer support. Book your Mumbai to Pune One Way Cab with Meghana Cab and experience reliable, on-time, and convenient intercity travel.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

     "topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "This grand 18th‑century fortification was the seat of the Maratha Peshwas. Built in 1732, much was destroyed by fire in 1828—what remains are the majestic walls, bastions, and gateways. The evening light‑and‑sound show (though occasionally disrupted) retells its dramatic history with flair, making it a must‑visit heritage site." 
    },
    {
      "title": "Aga Khan Palace",
      "description": "Constructed in 1892 by Sultan Aga Khan III, this elegant palace is deeply linked to India’s freedom struggle. It served as a prison for Mahatma Gandhi and his family. Today it houses a museum with Gandhi’s personal items and set beautifully amid landscaped grounds—a serene yet symbolic experience."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Perched about 30 km southwest of Pune at an altitude of ~1,317 m, this hill‑fort offers a historic trek with panoramic views. Site of the 1670 Battle of Sinhagad, it features gates, temples, and memorials, and is popular for sunrise hikes and local snacks served by vendors."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An 8th‑century rock‑cut Shiva temple carved from a single basalt boulder in Shivajinagar. Features a circular Nandi mandapa and pillars leading to an underground sanctum. It’s a peaceful, understated architectural marvel right in the city’s heart."
    },
    {
      "title": "Bhaja Caves",
      "description": "A group of 22 ancient Buddhist rock‑cut caves dating to the 2nd century BC, located near the Mumbai‑Pune highway. Highlights include stupas and a chaitya (prayer hall) with a vaulted horseshoe ceiling—an early masterpiece of rock architecture."
    },
    {
      "title": "Shinde Chhatri",
      "description": "Memorial hall built in 1794 to honor Maratha commander Mahadji Shinde. Located in Wanawadi, it blends Rajasthani and Anglo‑Islamic styles, with intricate carvings, colored‑glass windows, and a serene gallery."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "Housed in a charming Indo‑Saracenic building, this museum displays over 20,000 artifacts—from sculptures and musical instruments to weapons and paintings—collected by Dinkar Kelkar. It showcases everyday and ceremonial arts of India."
    },
    {
      "title": "Parvati Hill & Temple",
      "description": "One of Pune’s oldest hills crowned with temples to Shiva, Vishnu, Kartikeya and Ganesh. Accessible via 108 stone steps, it also has a museum and offers sweeping views of the city—perfect for history buffs and photographers."
    },
    {
      "title": "Bund Garden (Mahatma Gandhi Udyan)",
      "description": "Laid out in 1869 on the banks of the Mula River, this riverside park is a lush oasis with walking paths, migratory birds, and a children’s play area—popular among early‑morning walkers and family outings."
    },
    {
      "title": "Rajiv Gandhi Zoological Park",
      "description": "Spread over 130 acres, this zoo, snake park, and orphanage in Katraj is home to a diverse array of wildlife. It's a favorite for families and nature lovers seeking a green retreat within the city."
    }
  ],

    "services": [
    {
      "name": "Mumbai to Pune One Way Taxi",
      "description": "Book a reliable one-way taxi from Mumbai to Pune for a smooth, comfortable journey. Ideal for travelers seeking point-to-point service without the hassle of return trips."
    },
    {
      "name": "One Side Cab Mumbai to Pune",
      "description": "Get convenient one-side cab options from Mumbai to Pune with flexible booking and competitive pricing, perfect for quick and hassle-free travel."
    },
    {
      "name": "AC Cab Hire Mumbai to Pune",
      "description": "Travel comfortably in air-conditioned cabs that provide a cool and relaxing ride from Mumbai to Pune, suitable for both business and leisure travelers."
    },
    {
      "name": "Online Booking One Way Cab Mumbai to Pune",
      "description": "Easily book your one-way cab online with instant confirmation, secure payment options, and round-the-clock customer support for your Mumbai to Pune trip."
    },
    {
      "name": "Budget Travel Cab Mumbai to Pune",
      "description": "Choose affordable and budget-friendly cab services from Mumbai to Pune that don’t compromise on quality or comfort."
    },
    {
      "name": "SUV Taxi Mumbai to Pune One Way",
      "description": "Hire spacious and comfortable SUV taxis for your one-way trip from Mumbai to Pune, ideal for group travel and long-distance journeys."
    },
    {
      "name": "Sedan Cab Mumbai to Pune",
      "description": "Opt for elegant and comfortable sedan cabs for a smooth ride between Mumbai and Pune, perfect for small families and business travelers."
    },
    {
      "name": "Chauffeur Driven One Way Cab Mumbai to Pune",
      "description": "Enjoy a stress-free journey with professional chauffeur-driven taxis, ensuring safety, punctuality, and comfort for your one-way Mumbai to Pune travel."
    },
    {
      "name": "Private Car Mumbai to Pune",
      "description": "Experience privacy and exclusivity with private car hires, offering tailored services and direct routes from Mumbai to Pune."
    },
    {
      "name": "Fast Taxi Booking Mumbai to Pune One Way",
      "description": "Benefit from quick and easy taxi bookings online or via app, with instant confirmation for your one-way trip from Mumbai to Pune."
    },
    {
      "name": "Business Travel Cab Mumbai to Pune",
      "description": "Specialized taxi services catering to business travelers, providing professional, comfortable, and timely rides between Mumbai and Pune."
    },
    {
      "name": "Family Trip Cab Mumbai to Pune One Way",
      "description": "Safe and spacious cabs designed for family travel, ensuring a comfortable journey from Mumbai to Pune for all age groups."
    },
    {
      "name": "Long Distance Taxi Mumbai to Pune",
      "description": "Reliable long-distance taxi services equipped to handle extended trips from Mumbai to Pune, ensuring comfort and safety."
    },
    {
      "name": "Expressway One Way Cab Mumbai to Pune",
      "description": "Travel swiftly via the expressway with our efficient one-way cab services from Mumbai to Pune, saving time and ensuring a smooth ride."
    },
    {
      "name": "24-Hour Cab Service Mumbai to Pune",
      "description": "Avail our 24/7 taxi services from Mumbai to Pune, with availability at all hours to match your schedule and travel needs."
    }
  ],
  "tableData": [
    ["Mumbai to Pune One Way Taxi", "One Side Cab Mumbai to Pune"],
    ["AC Cab Hire Mumbai to Pune", "Online Booking One Way Cab Mumbai to Pune"],
    ["Budget Travel Cab Mumbai to Pune", "SUV Taxi Mumbai to Pune One Way"],
    ["Sedan Cab Mumbai to Pune", "Chauffeur Driven One Way Cab Mumbai to Pune"],
    ["Private Car Mumbai to Pune", "Fast Taxi Booking Mumbai to Pune One Way"],
    ["Business Travel Cab Mumbai to Pune", "Family Trip Cab Mumbai to Pune One Way"],
    ["Long Distance Taxi Mumbai to Pune", "Expressway One Way Cab Mumbai to Pune"],
    ["24-Hour Cab Service Mumbai to Pune", ""]
  ],



"whychoose": [
    {
        "WhyChooseheading": "Convenient Mumbai to Pune One Way Cab Service",
        "WhyChoosedescription": "Our Mumbai to Pune one-way cab service offers a seamless travel experience with prompt pickups and smooth drop-offs. Ideal for business travelers, airport transfers, students, or families, we ensure a stress-free ride with a professional touch."
    },
    {
        "WhyChooseheading": "Well-Maintained Fleet for Comfortable Journeys",
        "WhyChoosedescription": "Travel in clean, air-conditioned, and spacious cabs. Choose from a variety of well-maintained vehicles including sedans, SUVs, and premium cars—all regularly serviced and sanitized to deliver a safe and pleasant ride."
    },
    {
        "WhyChooseheading": "Trained, Polite, and Route-Savvy Drivers",
        "WhyChoosedescription": "Our drivers are courteous, experienced, and fully aware of the Mumbai–Pune Expressway and alternate routes. They ensure on-time arrivals, safe driving, and a comfortable journey, even during peak hours or long drives."
    },
    {
        "WhyChooseheading": "Affordable, Transparent Pricing with No Hidden Fees",
        "WhyChoosedescription": "Enjoy fixed, all-inclusive fares with complete clarity—no surprises or hidden charges. Your fare includes tolls, fuel, taxes, and driver allowances, ensuring great value for money and no last-minute cost shocks."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for Every Need",
        "WhyChoosedescription": "Whether you’re booking at the last minute or scheduling in advance, we offer flexible booking with instant confirmations. Choose your preferred time and location for both pickup and drop-off, anywhere in Mumbai or Pune."
    },
    {
        "WhyChooseheading": "Doorstep Pickup and Drop-off Service",
        "WhyChoosedescription": "Skip crowded pickup points or taxi queues. We offer true door-to-door service—our driver will arrive at your home, office, hotel, or Mumbai airport and drop you at your exact destination in Pune, hassle-free."
    },
    {
        "WhyChooseheading": "Perfect for Airport Transfers, Office Travel, and Weekend Trips",
        "WhyChoosedescription": "Whether you’re catching a flight, heading to a business meeting, or planning a weekend getaway to Pune, our one-way cab service offers flexibility, reliability, and comfort to suit your purpose of travel."
    },
    {
        "WhyChooseheading": "24/7 Booking Support and On-Road Assistance",
        "WhyChoosedescription": "Our customer care team is available 24/7 to assist you with bookings, changes, and travel queries. In case of delays or emergencies, you’ll always have support throughout your trip from Mumbai to Pune."
    }
]















    }

const faqData = [
    {
        question: "How do I book a one way cab from Mumbai to Pune?",
        answer: "You can book a one way cab by calling Meghana Cab at +91 9075462128 or via our website for quick online booking."
    },
    {
        question: "What is the typical travel time from Mumbai to Pune by cab?",
        answer: "The journey usually takes around 3 to 4 hours, depending on traffic conditions."
    },
    {
        question: "Are one way cabs from Mumbai to Pune available at all times?",
        answer: "Yes, we offer one way cab services 24/7 to fit your schedule."
    },
    {
        question: "What types of vehicles can I choose for Mumbai to Pune one way cab?",
        answer: "We provide hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers."
    },
    {
        question: "Does the fare for Mumbai to Pune one way cab include tolls and driver charges?",
        answer: "Yes, the fare includes fuel, tolls, and driver charges. Additional waiting or parking fees may apply."
    },
    {
        question: "Can I request stops for meals or rest during the trip?",
        answer: "Yes, stops can be arranged upon request. Please inform us when booking or notify the driver."
    },
    {
        question: "Is online payment available for one way cab bookings?",
        answer: "Yes, you can pay securely online using UPI, credit/debit cards, net banking, or cash."
    },
    {
        question: "Are last-minute bookings accepted for Mumbai to Pune one way cabs?",
        answer: "Yes, last-minute bookings are accepted subject to vehicle availability."
    },
    {
        question: "Is the one way cab service from Mumbai to Pune available on weekends and holidays?",
        answer: "Yes, our service operates every day including weekends and holidays."
    },
    {
        question: "Are the drivers experienced and reliable for Mumbai to Pune trips?",
        answer: "Absolutely. Our drivers are trained, background-verified, and familiar with the Mumbai to Pune route."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Ajay Mehta',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked a one way cab from Mumbai to Pune with Meghana Cab. Smooth ride and excellent driver!”',
    },
    {
        name: 'Ms. Nisha Rao',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Great experience with timely pickup and comfortable cab. Highly recommend Meghana Cab.”',
    },
];



































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune One Way Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/mumbai-to-pune-one-way-cab.jpg",
  "description": "Book reliable and affordable one-way cab service from Mumbai to Pune with Meghana Cabs. Choose from AC, SUV, and sedan options with professional drivers. Available 24/7 for business and family trips.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1700",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/mumbai-to-pune-one-way-cab"
  }
};









    return (
        <div>

<Helmet>
  <title>Mumbai to Pune One Way Cab Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book reliable and affordable one-way cab service from Mumbai to Pune with Meghana Cabs. Choose from AC, SUV, and sedan options with professional drivers. Available 24/7 for business and family trips." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Pune One Way Taxi, One Side Cab Mumbai to Pune, AC Cab Hire Mumbai to Pune, Online Booking One Way Cab Mumbai to Pune, Budget Travel Cab Mumbai to Pune, SUV Taxi Mumbai to Pune One Way, Sedan Cab Mumbai to Pune, Chauffeur Driven One Way Cab Mumbai to Pune, Private Car Mumbai to Pune, Fast Taxi Booking Mumbai to Pune One Way, Business Travel Cab Mumbai to Pune, Family Trip Cab Mumbai to Pune One Way, Long Distance Taxi Mumbai to Pune, Expressway One Way Cab Mumbai to Pune, 24-Hour Cab Service Mumbai to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/55.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitopuneonewaycab;